export const BorderRadius = {
    borderRadius: 8,
    borderRadiusSm: 12,
    borderRadiusMd: 16
};
//# sourceMappingURL=borderRadius.js.map